import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso3.vue?vue&type=template&id=88314462&lang=html"
import script from "./ParametrizacaoAcaoPasso3.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso3.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoAcaoPasso3.vue?vue&type=style&index=0&id=88314462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports